export const getPeriodLabel = (period?: string): string => {
    if (!period) {
        return '';
    }

    const normalized = period.toUpperCase();

    if (normalized === 'AMBOS') {
        return 'DIURNO E NOTURNO';
    }

    return period;
};
